
<fieldset class="text-center my-24 lg:mt-48">
  <legend class="sr-only">How many years of paid child care experience do you have?</legend>
  <poppins-counter ref="counter" v-model="yearsExperience" label="years" :min="0" :max="50" />
</fieldset>
